import * as React from 'react';
type IconInformacionLogisticaProps = React.SVGProps<SVGSVGElement>;

export const IconInformacionLogistica: React.FC<IconInformacionLogisticaProps> = (props) => (
	<svg
		width={66}
		height={58}
		viewBox="0 0 66 58"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<rect
			x="0.437286"
			y="52.5554"
			width="52.5554"
			height="56.1185"
			rx="3.95907"
			transform="rotate(-90 0.437286 52.5554)"
			fill="#EBF8F0"
		/>
		<ellipse
			cx="51.7062"
			cy="44.1431"
			rx="13.8565"
			ry="13.8569"
			fill="#7EAE90"
		/>
		<path
			d="M45.7682 45.021L49.5473 48.1003L57.6453 40.1821"
			stroke="#EBF8F0"
			stroke-width="3.95907"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M35.1773 1.1905C35.1773 0.533005 34.6443 0 33.9868 0H23.0063C22.3488 0 21.8158 0.533004 21.8158 1.1905V16.8258C21.8158 16.9592 21.9239 17.0673 22.0573 17.0673C22.105 17.0673 22.1516 17.0532 22.1912 17.0267L27.835 13.263C28.235 12.9963 28.7561 12.9963 29.1561 13.263L34.7994 17.0265C34.8394 17.0531 34.8863 17.0673 34.9343 17.0673C35.0685 17.0673 35.1773 16.9585 35.1773 16.8243V1.1905Z"
			fill="#FFA692"
		/>
		<rect
			x="21.8158"
			width="13.3615"
			height="3.74123"
			fill="#FFA692"
		/>
		<rect
			x="5.00003"
			y="39"
			width="10"
			height="9"
			rx="0.89077"
			stroke="#FFA692"
			stroke-width="1.33615"
		/>
		<rect
			x="20"
			y="39"
			width="10"
			height="9"
			rx="0.89077"
			stroke="#FFA692"
			stroke-width="1.33615"
		/>
	</svg>
);

export default IconInformacionLogistica;
